import React from 'react';

import LaunchAvailableSkillButton from '@magoosh/test_prep/app/ai_tutor/components/launch_available_skill_button';

import { Activity } from '../../types';

interface Props {
  activity: Activity;
  next?: boolean;
}

export default (props: Props) => {
  return (
    <>
      <div>
        <LaunchAvailableSkillButton domain={props.activity.content.domain} skill={props.activity.content.skill} />
      </div>

      {
        props.activity.hint && (
          <div className="hidden-xs small" dangerouslySetInnerHTML={{ __html: props.activity.hint }} />
        )
      }
    </>
  )
};
